<template>
    <div>
		<!-- <card>
			<ReSelectBlankServices />
		</card> -->

		<button class="btn btn-simple btn-primary" @click="AddBlank()">Запросить документ</button>

		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Найдено: {{this.masObjects_total}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			/>
		</div> 
		
		<!--
		{{ApiData}}
		-->

		<card>
			<el-table :data="ApiData" style="width: 100%;">
				<!--
				<el-table-column
					label="ID"
					property="id"
					width="80"
				>
				</el-table-column>
				-->
				<el-table-column
					label="Номер"
					property="blank_number"
					width="180"
				>
				</el-table-column>
				<el-table-column 
						min-width="180"
						label="Тип"
						property="blank_type"
				>
				</el-table-column>	
				<el-table-column 
						min-width="180"
						label="Кто запросил"
						property="a_fio" 
				>
				</el-table-column>	
				<el-table-column 
						min-width="180"
						label="На кого запросили"
						property="staff_fio"
				>
				</el-table-column>	
				<!-- <el-table-column 
						min-width="180"
						label="clientId "
						property="clientId"
				>
				</el-table-column>	 -->
				<el-table-column 
						min-width="180"
						label="Клиент"
						property="c_fio"
				>
					<template v-slot="scope">
						<router-link v-if="scope.row.clientId !=''" :to="`/data/clients/id/${scope.row.clientId}`">{{scope.row.c_fio}}</router-link>
					</template>
				
				</el-table-column>	
				<el-table-column 
						min-width="180"
						label="Файл"
				>
					<template v-slot="scope">
						<router-link v-if="scope.row.blank_number !=''" :to="`${scope.row.blank_file}`" target="_blank">Распечатать</router-link>
					</template>
				</el-table-column>
				<el-table-column 
						min-width="180"
						label="Дата запроса"
						property="dt_ins"
				>
				</el-table-column>
				<el-table-column 
						min-width="180"
						label="Статус"
						property="arman_status"
				>
				</el-table-column>				
			</el-table>
		</card>
		<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)" 
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>	
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import Pagination from 'src/our_components/RePagination';
// import ReSelectBlankServices from 'src/our_components/ReSelectBlankServices.vue';

export default {
	name: 'blanks-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReFilterBtn,
        ReFilter,
        Pagination,
		// ReSelectBlankServices,
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: true,
			masAllFilterParams: this.currentFilterConfig(),
			masObjects_total: 0,
			objGetParams:{},
		};
	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('blanks.GET',{flt:{...{act:1,order_field:'id desc'}, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						this.masObjects_total = objApi.total;
					}else{
						this.ApiData = [];
						this.masObjects_total = 0;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		sendBlank(){
			this.$GVO.ApiCall('blanks.INS',{'iData':{
				'staffId':11955,
				'structureId':'2E944C9B-B1F4-11E4-AF2E-080027B197A1',
				'autorId':2601,
				'clientId':7499,
				'blank_type':'Договор',
				'blank_service_type':'вид услуги',
				'blank_service':'услуга',
			}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('blanks.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						//console.log(objApi.config[0].elements[objApi.config[0].elements.length-1]);
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){ 
			//console.log('OnFilterApply_caller',new Error().stack);
			//console.log('OnFilterApply',data);

			let bFromObj = false;
			//console.log('OnFilterApply',SGVO.prevRoute);

			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined' && bFromObj==false){
				delete this.objGetParams['p'];
			}

			SGVO.prevRoute=null;
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		AddBlank(){
			this.$router.push({path: '/data/blanks/add'});
		},
	},		
	mounted() {
		//this.getApiData();
		this.objGetParams = this.$GVO.GetAllGet();
	}
};
</script>
<style>
</style>
